import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { NewColorCollectionButton } from "./components/color-collections/new-color-collection-button";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";

const ColorCollectionsContext = createContext();
export const useColorCollections = () => useContext(ColorCollectionsContext);
function ColorCollectionsProvider({ data, children }) {
  return (
    <ColorCollectionsContext.Provider value={data}>
      {children}
    </ColorCollectionsContext.Provider>
  );
}

function ColorCollectionsRenderer() {
  const elements = document.querySelectorAll(
    ".react-create-new-color-collection"
  );
  if (!elements) return;

  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for ColorCollections"
      );
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <ColorCollectionsProvider data={initialProps}>
            <NewColorCollectionButton />
          </ColorCollectionsProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initColorCollections = () => {
  if (document.readyState !== "loading") {
    ColorCollectionsRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", ColorCollectionsRenderer);
  }
};
